<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'

defineProps({
  id: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  modelValue: {
    type: Boolean,
    default: false
  },
  name: {
    type: String,
    required: true
  },
  value: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['update:modelValue'])

const emitUpdateModelValue = (checked: boolean) => {
  emit('update:modelValue', checked)
}
</script>

<template>
  <label
    :for="id"
    data-test="tag-pill"
    :class="['tag-pill', { 'tag-pill--active': modelValue }]"
  >
    <input
      :id="id"
      type="checkbox"
      :name="name"
      :value="value"
      :checked="modelValue"
      @change="
        emitUpdateModelValue($event.target ? $event.target.checked : false)
      "
    />
    <span class="tag-pill__label body--p2--medium">
      {{ label }}
    </span>
  </label>
</template>

<style lang="scss" scoped>
@use '@base/styles/v1.0/scss/foundations/breakpoint';
@use '@base/styles/v1.0/scss/foundations/color';

.tag-pill {
  background-color: color.$color--neutral-a5;
  border-radius: 18px; // doesn't use foundation
  border: var(--line-weight--light) solid color.$color--primary-b3;
  color: color.$color--neutral-a1;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  padding: var(--spacing--9) var(--spacing--8);
  text-align: center;
  user-select: none;

  &:active,
  &--active {
    background-color: color.$color--primary-b3;
    color: color.$color--neutral-a5;
  }

  &:focus,
  &:hover {
    // border-width: var(--line-weight--heavy);  // causes jump
    box-shadow: inset 0px 0px 0px 1px color.$color--primary-b3;
  }

  &__label {
    text-transform: uppercase;
    white-space: nowrap;
  }
}
</style>
